
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.123 5.376L27.17.814a1 1 0 011.24.472l5.892 11.27a1 1 0 01.061.781l-3.946 11.744a1 1 0 01-1.238.639l-18.202-5.497a1 1 0 01-.662-1.266l4.21-12.954a1 1 0 01.597-.627zM16.75 8l-2 6L21 16.25 22.75 10l-6-2z","fill":"#11AEFA"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.25 6.75H6a.25.25 0 01.242.187L7.427 11.5H36.25a.25.25 0 01.24.32l-4.235 14.447.53 3.442-.494.076-.505-3.285H11.153l-1.292 2.585-.447-.223 1.32-2.64L5.807 7.25H3.25v-.5zM11.193 26h20.62l4.103-14H7.557l3.636 14z","fill":"#001C45"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.194 11.455l1.51 7.295h6.287l-.25-7.241.5-.017.25 7.258h6.548l1.257-7.289.493.085-1.242 7.204H34v.5h-5.54l-1.256 7.289-.493-.085 1.242-7.204H21.51l.25 7.241-.5.018-.25-7.259h-6.202l1.489 7.194-.49.102-1.51-7.296H9v-.5h5.193l-1.489-7.194.49-.101z","fill":"#001C45"}}),_c('path',{attrs:{"d":"M11 30.25a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zM35.5 30.25a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zM0 6a.5.5 0 01.5-.5H4a.5.5 0 01.5.5v2a.5.5 0 01-.5.5H.5A.5.5 0 010 8V6z","fill":"#F9C258"}})])
          )
        }
      }
    